import React from "react";
import Login from "./Login";

const UnAuthenticatedApp = () => {
  
  return <Login />;
};

export default UnAuthenticatedApp;
